require('./referralsPreview.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

class ReferralsPreview extends React.Component {

    renderModalWithoutEmail() {
        const { invitationCode, promotionCode } = this.props;
        return (
            <div>
                <h4 className="referrals-preview__message-email-share">
                    <FormattedText value="referralsPreview-withoutEmailTitle" />
                </h4>
                <div className="referrals-preview">
                    <div className="referrals-preview__modal-content">
                        <div className="referrals-preview__content-email">
                            <div className="referrals-preview__content-email-logo-openbank" />
                            <div className="referrals-preview__content-email-text">
                                <FormattedText
                                    injectedStrings={[invitationCode]}
                                    value={`referralsPreview-withoutEmail_${promotionCode}`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { email } = this.props;
        let content = (<div></div>);

        if (!email) {
            content =this.renderModalWithoutEmail();
        }

        return content;
    }
}

ReferralsPreview.propTypes = {
    email: PropTypes.string,
    invitationCode: PropTypes.string,
    promotionCode: PropTypes.string,
};

ReferralsPreview.defaultProps = {
    email: '',
    invitationCode: '',
    promotionCode: '',
};

module.exports = ReferralsPreview;

